import { InputNumber } from "antd";
import styled from "styled-components";
import UdfBaseRangeField from "./UdfBaseRangeField";

const StyledInputNumber = styled(InputNumber)`
  flex: 1;
  margin-right: 8px;
`;

/**
 * Display component for integer range values
 * Handles: arrays, full range, min only (≥), max only (≤), single value
 */
function UdfIntegerRangeDisplay({ value }) {
  // Handle array of values
  if (Array.isArray(value)) {
    return (
      <>
        {value.map((val, index) => (
          <span key={index}>
            <UdfIntegerRangeDisplay value={val} />
            {index < value.length - 1 && ", "}
          </span>
        ))}
      </>
    );
  }

  // Handle range object
  if (value && typeof value === "object") {
    if (value.min_value != null && value.max_value != null) {
      return (
        <>
          {value.min_value} - {value.max_value}
        </>
      );
    }
    if (value.min_value != null) {
      return <>≥ {value.min_value}</>;
    }
    if (value.max_value != null) {
      return <>≤ {value.max_value}</>;
    }
  }

  // Fallback: primitive value
  return String(value);
}

/**
 * Validate integer range: min <= max
 */
function validateIntegerRange(min, max) {
  if (min == null || max == null) return true; // Partial range OK
  return min <= max;
}

/**
 * Integer range input component for UDF filters
 */
function UdfIntegerRangeEdit({ addValue, currentValue, setCurrentValue, canAddCurrentValue }) {
  return (
    <UdfBaseRangeField
      minValue={currentValue?.min_value}
      maxValue={currentValue?.max_value}
      onValueChange={setCurrentValue}
      onAddValue={() => addValue(currentValue)}
      minKey="min_value"
      maxKey="max_value"
      minLabel="Min"
      maxLabel="Max"
      validateRange={validateIntegerRange}
      canAddValue={canAddCurrentValue}
      renderMinInput={(props) => (
        <StyledInputNumber
          {...props}
          step={1}
          precision={0}
          parser={(v) => v.replace(/[^\d-]/g, "")}
          formatter={(v) => v}
        />
      )}
      renderMaxInput={(props) => (
        <StyledInputNumber
          {...props}
          step={1}
          precision={0}
          parser={(v) => v.replace(/[^\d-]/g, "")}
          formatter={(v) => v}
        />
      )}
    />
  );
}

/**
 * Factory function that returns both Edit and Display components
 */
function UdfIntegerRange() {
  return {
    Edit: UdfIntegerRangeEdit,
    Display: UdfIntegerRangeDisplay,
  };
}

export default UdfIntegerRange;
